import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const NotificationPopup = ({ message, type, onClose, isVisible }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = window.setTimeout(() => {
        onClose();
      }, 5000);
      return () => window.clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  const variants = {
    hidden: { opacity: 0, y: -50, x: '-50%' },
    visible: { opacity: 1, y: 0, x: '-50%' },
    exit: { opacity: 0, y: -20, x: '-50%' },
  };

  const bgColor =
    type === 'success'
      ? 'bg-green-100 border-green-500 text-green-800'
      : 'bg-red-100 border-red-500 text-red-800';

  const icon =
    type === 'success' ? (
      <svg
        className='w-6 h-6 mr-2'
        fill='none'
        stroke='currentColor'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M5 13l4 4L19 7'
        ></path>
      </svg>
    ) : (
      <svg
        className='w-6 h-6 mr-2'
        fill='none'
        stroke='currentColor'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M6 18L18 6M6 6l12 12'
        ></path>
      </svg>
    );

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className={`fixed top-8 left-1/2 transform -translate-x-1/2 z-[9999] flex items-center p-4 border-l-4 rounded shadow-lg ${bgColor} min-w-[300px] max-w-md`}
          initial='hidden'
          animate='visible'
          exit='exit'
          variants={variants}
          transition={{ duration: 0.3 }}
        >
          {icon}
          <div className='flex-1'>{message}</div>
          <button
            onClick={onClose}
            className='ml-4 text-gray-500 hover:text-gray-700 focus:outline-none'
          >
            <svg
              className='w-4 h-4'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M6 18L18 6M6 6l12 12'
              ></path>
            </svg>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

NotificationPopup.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  type: PropTypes.oneOf(['success', 'error']).isRequired,
  message: PropTypes.string.isRequired,
};

export default NotificationPopup;
